import { render, staticRenderFns } from "./AdminMenuGroup.vue?vue&type=template&id=27f5c3e1&scoped=true&"
import script from "./AdminMenuGroup.vue?vue&type=script&lang=js&"
export * from "./AdminMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuGroup.vue?vue&type=style&index=0&id=27f5c3e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5c3e1",
  null
  
)

export default component.exports